export const USER_RETAILERS_LENGTH = 15;
export const GUEST_RETAILERS_LENGTH = 5;
